<!-- eslint-disable-next-line @angular-eslint/template/no-autofocus -- Claims the document's one autofocus slot before any PrimeNG control renders: browsers honour only the first candidate and the SPA never reloads, so stamped autofocus on toasts, switches and sliders never steals focus or scroll. -->
<span class="sr-only" tabindex="-1" autofocus></span>
<!-- Router Outlet for page content -->
<router-outlet></router-outlet>
